export interface WineTopProps{
  title: string;
  description: string;
  slug: string;
  author: string;
  issueDate: string;
  imageUrl?: string;
  subscribersOnly: boolean;
  wines: Array<WinesTopEntry>;
}

export interface WinesTopEntry {
  id: number;
  wineName: string;
  rank: number;
  scoreRaw: string;
  price: number;
  slug: string;
  vintage: number;
  tastingNote: string;
  author: string;
  tastedOn: string;
  producerName: string;
  thumbnailUrl?: string;
  extraNote?: string;
  overwriteWineName?: string;
  region2?: string;
  country?: string;
  color?: string;
}

export const defineRegionTextColor = (color: string) => {
  const mustardColors = ["sparkling white", "sweet white", "white"];
  const colorLower = color?.toLowerCase();

  if (mustardColors.includes(colorLower)) {
    return "text-mustard";
  } else {
    return "text-red";
  }
};